import React, { useEffect, useState } from "react";
import { Modal, Button, Spinner, Table, Collapse } from "react-bootstrap";
import api from "../../../service/api";

const JsonViewer = ({ json }) => {
    const [open, setOpen] = useState(false);
    let pretty = '';
    let error = null;
    let value = json;
    if (typeof json === 'string') {
        try {
            value = JSON.parse(json);
        } catch (e) {
            // Not a valid JSON string, show as is
            value = json;
            error = 'Invalid JSON';
        }
    }
    try {
        pretty = JSON.stringify(value, null, 2);
    } catch (e) {
        pretty = String(value);
        error = 'Invalid JSON';
    }
    return (
        <div>
            <Button
                variant="link"
                size="sm"
                onClick={() => setOpen(!open)}
                aria-controls="json-collapse"
                aria-expanded={open}
                style={{ padding: 0 }}
            >
                {open ? "Hide JSON" : "Show JSON"}
            </Button>
            <Collapse in={open}>
                <div id="json-collapse">
                    <pre style={{ maxHeight: 200, overflow: "auto", background: "#f8f9fa", borderRadius: 4, padding: 8 }}>
                        {pretty}
                    </pre>
                    {error && <div style={{ color: 'red', fontSize: 12 }}>{error}</div>}
                </div>
            </Collapse>
        </div>
    );
};

const ReSyncLMSModal = ({ show, onHide, batchId, onSyncSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [syncing, setSyncing] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState([]);
    const [syncResult, setSyncResult] = useState(null);

    useEffect(() => {
        if (show && batchId) {
            setLoading(true);
            setError(null);
            setSyncResult(null);
            api.get(`tms/batches/sqs-logs/${batchId}`)
                .then((res) => {
                    setData(res.data || []);
                })
                .catch((err) => {
                    setError(err.message || "Failed to fetch data");
                })
                .finally(() => setLoading(false));
        }
    }, [show, batchId]);

    const handleSync = () => {
        setSyncing(true);
        setError(null);
        api.post(`tms/batches/sync-students/${batchId}`)
            .then((res) => {
                setSyncResult(res.data || "Sync successful");
                if (onSyncSuccess) onSyncSuccess();
            })
            .catch((err) => {
                setError(err.message || "Sync failed");
            })
            .finally(() => setSyncing(false));
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" scrollable>
            <Modal.Header closeButton>
                <Modal.Title>Re-sync to LMS Preview</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center"><Spinner animation="border" /></div>
                ) : error ? (
                    <div className="text-danger">{error}</div>
                ) : (
                    <Table bordered hover size="sm">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Module</th>
                                <th>Status</th>
                                <th>Message</th>
                                <th>JSON</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.length === 0 ? (
                                <tr><td colSpan={5} className="text-center">No data</td></tr>
                            ) : data.map((item, idx) => (
                                <tr key={item.id || idx}>
                                    <td>{idx + 1}</td>
                                    <td>{item.module || "-"}</td>
                                    <td>{item.status || "-"}</td>
                                    <td>{item.message || "-"}</td>
                                    <td><JsonViewer json={item?.payload} /></td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
                {syncResult && <div className="text-success mt-2">{typeof syncResult === 'string' ? syncResult : JSON.stringify(syncResult)}</div>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={syncing}>Close</Button>
                <Button variant="primary" onClick={handleSync} disabled={syncing || loading}>
                    {syncing ? <Spinner size="sm" animation="border" /> : "Sync"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ReSyncLMSModal;
